export default "__VITE_ASSET__DqTrw6bJ__"